import * as R from "ramda";
import { getAssignUser } from "../../helpers/api/api";
import {
  clearError,
  startLoading,
  stopLoading,
  saveErrorMsg,
} from "../../helpers/api/meta";

export const ADMIN_LOAD_STARTED = "ADMIN_LOAD_STARTED";
export const ADMIN_LOAD_SUCCESS = "ADMIN_LOAD_SUCCESS";
export const ADMIN_LOAD_FAILURE = "ADMIN_LOAD_FAILURE";
export const ADMIN_LOAD_ENDED = "ADMIN_LOAD_ENDED";

export const adminLoadStarted = () => ({ type: ADMIN_LOAD_STARTED });
export const adminLoadSuccess = (response) => ({
  type: ADMIN_LOAD_SUCCESS,
  response,
});
export const adminLoadFailure = (error) => ({
  type: ADMIN_LOAD_FAILURE,
  error,
});
export const adminLoadEnded = () => ({ type: ADMIN_LOAD_ENDED });

const saveAdmin = (state, action) => {
  const assignUser = R.assoc("assignUser", action.response, state);
  return R.assoc("totalCount", action.response.count, assignUser);
};

const messages = {
  loadFailed: "Loading users failed.",
};

const initialState = {
  loading: false,
  totalCount: 0,
  assignUser: [],
};

export const loadAssignUserList = (params) => (dispatch) => {
  dispatch(adminLoadStarted());
  return getAssignUser(params)
    .then((assignUser) => {
      dispatch(adminLoadEnded());
      dispatch(adminLoadSuccess(assignUser));
    })
    .catch((error) => {
      dispatch(adminLoadEnded());
      dispatch(adminLoadFailure(error));
    });
};

export default function adminListReducer(state = initialState, action) {
  switch (action.type) {
    case ADMIN_LOAD_FAILURE: {
      return saveErrorMsg(state, action, messages.loadFailed);
    }
    case ADMIN_LOAD_ENDED: {
      return stopLoading(state);
    }
    case ADMIN_LOAD_STARTED: {
      return startLoading(clearError(state));
    }
    case ADMIN_LOAD_SUCCESS: {
      return saveAdmin(state, action);
    }
    default:
      return state;
  }
}
